import { InputAdornment } from '@mui/material';
import React from 'react';

// Actions

// Components

// Others

const getFlagImage = currencyCode => {
  const flagDirectory = process.env.PUBLIC_URL + '/images/flag';
  switch (currencyCode) {
    case 'CAD':
      return <img src={`${flagDirectory}/CA.png`} alt="currency" style={{ marginTop: '-0.25rem' }} />;
    case 'USD':
      return <img src={`${flagDirectory}/US.png`} alt="currency" style={{ marginTop: '-0.25rem' }} />;

    default: {
      return currencyCode || '';
    }
  }
};

export const MoneyAdornment = ({ position, currencyCode }) => {
  return <InputAdornment position={position || 'end'}>{getFlagImage(currencyCode)}</InputAdornment>;
};

export const MoneyFlag = ({ currencyCode }) => {
  return <span style={{ marginLeft: '5px' }}>{getFlagImage(currencyCode)}</span>;
};
